import { useBoolean } from "ahooks";
import { Button, message, Modal, Input } from "antd";
import { ColumnsType } from "antd/lib/table";
import React, { useContext, useEffect, useState } from "react";
import { ButtonPanel } from "../../../../component/button-panel/button_panel";
import { DataTable } from "../../../../component/table";

import img_edit from "../../../../assets/images/bianji.png"
import img_see from "../../../../assets/images/chakan1.png"
import img_del from "../../../../assets/images/shanchu.png"
import { fileAction } from "../../action/reduceGrade/file_action";
import { FormStoreProvider } from "../../store/reduceGrade/form_store";
import { Form } from "./form";
import { formAction } from "../../action/reduceGrade/form_action";
import { DataTableStore } from "../../../../component/table/store/data_table_store";

import { FileStore } from "../../store/reduceGrade/file_store";
import { Search } from "../../../../component/search";
import { ConfirmModal } from "../../../../component/modal";
import { defualtPageSize, Progress } from "../../../../logic/common_logic";
import { AuthLogic } from "../../../../logic/auth_logic";
import { Control, Del, Edit, See } from "../../../../component/control-column";


const formParams = {
    method: "Create",
    id: ""
}
export function ReduceGrade(viewPower) {
    const [createState, createFunc] = useBoolean(false);
    const [confirmState, confirmFunc] = useBoolean(false);
    const [deleteState] = useBoolean(false);
    const [] = useBoolean(false);
    const action = fileAction;
    const { state, dispatch } = useContext(FileStore);
    const { state: tableState, dispatch: tableDispatch } = useContext(DataTableStore);
    const [menuButton, setData] = useState([])
    useEffect(() => {
        (async function () {
            let r = await new AuthLogic().selButton(viewPower.viewPower);
            if (r&&r.length > 0) {
                for (let i = 0; i < r.length; i++) {

                    r[i] = r[i].split('_')[r[i].split('_').length - 1]
                }
            }
            setData(r);
        }())

        return () => {

        }
    }, []);
    const columns: ColumnsType = [
        {
            title: '操作',
            key: '1',
            align: "center",
            width: Control.width(3),
            render: Control.render(
                v => menuButton.indexOf("VIEW") != -1 && <See click={() => {
                    formParams.id = v.id;
                    formParams.method = 'Preview'
                    createFunc.setTrue();
                }} />,
                v => menuButton.indexOf("UPDATE") != -1 && <Edit click={() => {
                    formParams.id = v.id;
                    formParams.method = 'Update'
                    createFunc.setTrue();
                }} />,
                v => menuButton.indexOf("DELETE") != -1 && <Del click={() => {
                    formParams.id = v;
                    formParams.method = 'Delete'
                    confirmFunc.setTrue();
                }} />
            )
        },
       
        {
            title: '创建时间',
            dataIndex: 'addDateTime',
            key: '3',
            align: "center"
        },
       
    ];
    const onSearch = async (pageIndex) => {
        //console.log(pageIndex)
        await action.loadPage({ pageIndex: pageIndex, pageSize: defualtPageSize(), dispatch: tableDispatch, search: state.search })
    }
    return (
        <>
            <Search>
                <Input allowClear placeholder="请输入等级名称" onChange={e => action.setCondition("Keywords", e.target.value, dispatch)} />
                <input type="button" value="快速查找" onClick={() => onSearch(1)} />
            </Search>
            <ButtonPanel>
                {menuButton.indexOf("ADD") != -1 &&
                    <Button onClick={() => {
                        formParams.id = "";
                        formParams.method = "Create";
                        createFunc.setTrue();
                    }}>新建等级</Button>
                }
                {/* {menuButton.indexOf("DELETE") != -1 &&
                    <Button onClick={async () => {
                        if (!tableState.selectList.length) {
                            message.warning("请选择删除项")
                        } else {
                           confirmFunc.setTrue()
                        }
                    }}>批量删除</Button>
                } */}
            </ButtonPanel>

            <DataTable columns={columns} action={fileAction}
                onLoad={async () => { await onSearch(1); Progress.done() }}
                onChange={(pageIndex) => { onSearch(pageIndex) }}
                scroll={{ scrollToFirstRowOnChange: true, autoY: true }}
                selectColumn={true}
                loading={ tableState.loading }
            />

            {
                createState && (
                    <FormStoreProvider>
                        <Form close={(hasUpdate) => {
                            if (hasUpdate) {
                                onSearch(tableState.current);
                            }

                            createFunc.setFalse();

                        }} action={formAction} id={formParams.id} method={formParams.method} />
                    </FormStoreProvider>
                )
            }

            <ConfirmModal visible={confirmState} title="温馨提示" subTitle="确认删除？" message="删除之后信息无法恢复，请慎重考虑" close={async (r) => {
                if (r) {
                    if(tableState.selectList.length>0){
                        await action.delSelectList({ dispatch, selectList: tableState.selectList})

                        action.clearSelectedRowKeys({ dispatch: tableDispatch });

                        await onSearch(tableState.current);
                    }else{
                        await action.delRow({ dispatch, rowItem: formParams })
                        onSearch(tableState.current);
                    }
              
                }
                confirmFunc.setFalse();
            }} />
        </>
    )
}

function setData(r: any) {
    throw new Error("Function not implemented.");
}
